import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import store from './store'
import './plugins/axios'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/element.js'

Vue.prototype.$http = axios
axios.defaults.baseURL = 'https://api.admin.uuunnniii.com/v1'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
